import { IChatShareRepository, ChatShareEntity } from '@gishub/domain';

const STORAGE_PREFIX = 'chat-share-';

export class ChatShareRepository implements IChatShareRepository {
  save(data: ChatShareEntity): string {
    const id = crypto.randomUUID();
    localStorage.setItem(STORAGE_PREFIX + id, JSON.stringify(data));
    return id;
  }

  load(id: string): ChatShareEntity | null {
    const raw = localStorage.getItem(STORAGE_PREFIX + id);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as ChatShareEntity;
    } catch {
      return null;
    }
  }
}
